<script>import {
  WeekNumberSystem,
  getMonthIndices,
  getMonthLabels,
  getFirstMonth
} from "../../../util/date-time-util.js";
import Picker from "./Picker.svelte";
import { createEventDispatcher } from "svelte";
export let name = void 0;
export let value = Math.floor((/* @__PURE__ */ new Date()).getMonth() / 3) * 3;
export let makeSquare = true;
const dispatch = createEventDispatcher();
let cellContentPadding = "0em";
let cellPadding = "0.3em";
let columns = 2;
let open = false;
const getQuarterCell = (monthIndex, cellIndex, columns2) => {
  return {
    type: "primary",
    marked: false,
    selected: monthIndex === value,
    inside: false,
    value: monthIndex,
    label: "Q" + (Math.floor(monthIndex / 3) + 1).toString(),
    valueTop: cellIndex < columns2,
    valueLeft: cellIndex % columns2 === 0
  };
};
let cells = [0, 3, 6, 9].map(
  (monthIndex, cellIndex) => getQuarterCell(monthIndex, cellIndex, columns)
);
const cellClicked = (ev) => {
  const index = ev.detail.index;
  const cell = ev.detail.cell;
  if (cell && !cell.disabled && (cell.type === "primary" || cell.type === "secondary")) {
    cells = cells.map((c, i) => {
      c.selected = i === index;
      return c;
    });
    value = cells[index].value;
    dispatch("changed", { name, value });
    open = false;
  }
  dispatch("action");
};
const moveTo = (delta) => {
  console.log("month-picker moveTo with cur value = ", value);
  if (value !== void 0) {
    value += delta;
    dispatch("changed", { name, value });
  }
  open = false;
  dispatch("action");
};
const showCells = () => {
  if (cells !== void 0 && cells.length > 0) {
    open = true;
  }
  dispatch("action");
};
</script>

<div
	class="picker quarter-picker"
	on:blur={() => {
		open = false;
	}}
	tabindex="-1"
>
	<span>
		<span
			class="button icon-chevron-left"
			on:keypress={(ev) => moveTo(-3)}
			on:click={(ev) => moveTo(-3)}
			role="button"
			tabindex="0"
		/><span class="open" role="button" tabindex="0" on:keypress={showCells} on:click={showCells}
			>{value !== undefined ? 'Q' + (Math.floor(value / 3) + 1).toString() : ''}</span
		><span
			class="button icon-chevron-right"
			on:keypress={(ev) => moveTo(+3)}
			on:click={(ev) => moveTo(+3)}
			role="button"
			tabindex="0"
		/>
	</span>
	<div class={open ? 'open' : ''}>
		<Picker
			{cells}
			cellCharWidth={3}
			itemCharWidth={2}
			{cellContentPadding}
			{cellPadding}
			{columns}
			{makeSquare}
			on:cell-click={cellClicked}
		/>
	</div>
</div>

<style>
	div.picker {
		--base-color-onSurface-primary: #dbe4e7;
		--base-color-primary-default: #6bae85;
		--font-family: Roboto;
		--font-size: 1.125rem;
		--font-weight: 700;
		--letter-spacing: 0.0625rem;
	}

	div.picker {
		--picker-font: normal var(--font-weight) var(--font-size) / 1.2 var(--font-family);
		--picker-font-spacing: var(--letter-spacing);
		--picker-text-color: var(--base-color-onSurface-primary);
		--picker-button-color: var(--base-color-primary-default);
	}

	div.picker.quarter-picker {
		display: inline-block;
		vertical-align: bottom;
	}

	.picker > span {
		background-color: transparent;
		color: var(--picker-text-color);
		font: var(--picker-font);
		letter-spacing: var(--picker-font-spacing);
		line-height: 1.22222;
	}

	.picker > div {
		position: absolute;
		display: none;
		left: 0;
	}
	.picker > div.open {
		display: block;
		z-index: 10000;
	}

	div.picker.quarter-picker > span {
		display: inline-flex;
		align-items: center;
		align-content: stretch;
		gap: 0.65em;
	}

	div.picker.quarter-picker > span > span.open {
		flex: 1 0 auto;
		cursor: pointer;
	}
	div.picker.quarter-picker > span > span.button {
		flex: 0 0 auto;
		cursor: pointer;
	}
</style>
